import { Ingredient } from '../types/src';

export function mapIngredientToLocale(ings: Ingredient[], locale: string): string {
  return ings.map((ing) => (ing.names[locale] ? ing.names[locale] : '')).join(', ');
}
